<template>
  <div v-loading="isLoading" style="padding:20px;width:100%" class="popup_tabs">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">IP 스캔</div>
      </div>
      <div class="vertical-center-box">
        <el-select v-model="agentManagerId">
          <el-option v-for="item in agentMgrList" :key="item.agentManagerId" :label="item.agentManagerIpaddress" :value="item.agentManagerId"></el-option>
        </el-select>
        <el-button v-if="managerType === 'ADMIN'" class="mr-l4" @click="onClickRestConnectionButton">연결 상태 초기화</el-button>
      </div>
    </el-row>
    <el-tabs v-model="activeTabName" type="border-card">
      <el-tab-pane :label="tabs['icmp'].label" :name="tabs['icmp'].name" class="h100 w100">
        <w-ip-scan-tab-panel :tab-info="tabs['icmp']" :agent-manager-id="agentManagerId" :obj-info="objInfo" />
      </el-tab-pane>
      <el-tab-pane :label="tabs['snmp'].label" :name="tabs['snmp'].name" class="h100 w100">
        <w-ip-scan-tab-panel :tab-info="tabs['snmp']" :agent-manager-id="agentManagerId" :obj-info="objInfo" :default-port="161"/>
      </el-tab-pane>
      <el-tab-pane :label="tabs['tcp'].label" :name="tabs['tcp'].name" class="h100 w100">
        <w-ip-scan-tab-panel :tab-info="tabs['tcp']" :agent-manager-id="agentManagerId" :obj-info="objInfo" />
      </el-tab-pane>
      <el-tab-pane :label="tabs['udp'].label" :name="tabs['udp'].name" class="h100 w100">
        <w-ip-scan-tab-panel :tab-info="tabs['udp']" :agent-manager-id="agentManagerId" :obj-info="objInfo" />
      </el-tab-pane>
      <el-tab-pane :label="tabs['traceroute'].label" :name="tabs['traceroute'].name" class="h100 w100">
        <w-ip-scan-tab-panel :tab-info="tabs['traceroute']" :agent-manager-id="agentManagerId" :obj-info="objInfo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import IpScanAPI from '@/api/ip-scan';
import MibAPI from '@/api/mib';
import WIpScanTabPanel from './components/IpScanTabPanel';

export default {
  name: 'WIpScan',
  components: {
    WIpScanTabPanel,
  },
  data() {
    return {
      isLoading: false,
      agentMgrList: [],
      agentManagerId: 0,
      objInfo: null,
      activeTabName: 'icmp',
      tabs: {
        icmp: {
          name: 'icmp',
          label: 'ICMP 스캔',
          active: false,
          default: true,
        },
        snmp: {
          name: 'snmp',
          label: 'SNMP 스캔',
          active: false,
        },
        tcp: {
          name: 'tcp',
          label: 'TCP 스캔',
          active: false,
        },
        udp: {
          name: 'udp',
          label: 'UDP 스캔',
          active: false,
        },
        traceroute: {
          name: 'traceroute',
          label: 'TRACEROUTE 스캔',
          active: false,
        },
      },
    };
  },
  computed: {
    managerType() {
      const userInfo = this.$store.getters.userInfo;
      if (isNil(userInfo)) {
        return null;
      }
      return userInfo.managerType;
    },
  },
  watch: {
    activeTabName: {
      handler(to, from) {
        const tabs = this.tabs;
        tabs[from].active = false;
        tabs[to].active = true;
      },
    },
  },
  created() {
    this.$store.dispatch('openFullScreenLayer');
    document.body.className += ' ipscan_popup ';
  },
  mounted() {
    const objId = this.$route.params.objId;
    IpScanAPI.getAgentMgrList().then((response) => {
      const result = response.data;
      if (result.success) {
        this.agentMgrList = result.data;
      }
    });
    if (!isNil(objId)) {
      IpScanAPI.getAgentManagerIdByObjId(objId).then((response) => {
        const result = response.data;
        if (result.success) {
          const agentManagerId = result.data;
          this.agentManagerId = agentManagerId;
        }
      });
      MibAPI.getObjInfo(objId).then((response) => {
        const result = response.data;
        if (result.success) {
          this.objInfo = result.data;
        }
      });
    }
  },
  methods: {
    onClickRestConnectionButton() {
      const messageOptions = {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false,
        showClose: false,
        type: 'warning',
        customClass: 'width-450px',
      };
      this.$confirm('초기화를 진행하면 수집서버와의 연결이 일시적으로 중단됩니다.<br/> 초기화를 진행하시겠습니까?', '확인', messageOptions).then(() => {
        this.isLoading = true;
        IpScanAPI.resetConnectionStatus(this.agentManagerId).then(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 5000);
        }).catch(() => {});
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.el-tabs--border-card {
  height:calc(100vh - 78px);
  min-height: 720px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/IpScan/index.vue